export default __webpack_public_path__ + "static/media/icon_excelsior.0142fc16.png";